<template>
  <div class="pa-4 mb-8">
    <v-row justify="center">
      <h2 class="display-1 pb-4">{{ step.title }}</h2>
      <v-col cols="8">
        {{ step.description }}
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="8" class="pt-0">
        <v-list style="height: 250px; overflow-y: auto; overflow-x: hidden;" class="pt-0">
          <v-slide-y-transition group leave-absolute>
            <v-list-item v-for="(item, n) in concerns" :key="item.text" style="width: 430px;">
              <v-list-item-icon>
                <v-icon small class="blue--text">check_circle</v-icon>
              </v-list-item-icon>
              <v-text-field
                v-if="editConcern === n"
                autofocus
                v-model="item.text"
                @keypress.enter="editConcern = false"
                @blur="editConcern = false"
              ></v-text-field>
              <v-list-item-title v-else class="font-weight-bold" @click="editConcern = n">{{
                item.text
              }}</v-list-item-title>
              <v-btn icon small @click.stop="removeConcern(item.text)">
                <v-icon small>close</v-icon>
              </v-btn>
            </v-list-item>
            <template v-for="(item, n) in sugArray">
              <v-list-item
                v-if="item.type == 'label'"
                :key="item.text"
                style="width: 430px; opacity: 0.6;"
              >
                <v-list-item-title class="subtitle-1 pb-0 mb-0">{{ item.text }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-else-if="item.type == 'suggestion'"
                :key="item.text"
                @click="addSuggestion(item, n)"
                style="opacity: 0.6; width: 430px;"
              >
                <v-list-item-icon><v-icon small>add</v-icon></v-list-item-icon>
                <v-list-item-title>{{ item.text }}</v-list-item-title>

                <v-btn icon @click.stop="removeSuggestion(item)"
                  ><v-icon small>close</v-icon></v-btn
                >
              </v-list-item>
            </template>
          </v-slide-y-transition>
        </v-list>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="8">
        <v-text-field
          v-model="newConcern"
          autofocus
          hide-details
          :placeholder="step.placeholder"
          @keypress.enter="
            concerns.push({ text: newConcern, questions: [], qSuggestions: [] });
            newConcern = '';
          "
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="8" class="caption">
        <p class="mb-0"><strong>Tip:</strong>{{ step.tip }}</p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ['step'],
  data() {
    return {
      suggestions: [],
      newConcern: '',
      concerns: [],
      editConcern: false
    };
  },
  mounted() {
    this.suggestions = [...this.step.suggestions];
  },
  watch: {
    concerns: function(n) {
      this.$emit('input', n);
    }
  },
  computed: {
    sugArray() {
      let result = this.concerns.map(c => ({ ...c, type: 'concern' }));
      if (this.suggestions.length) {
        result = result.concat([{ text: 'Suggestions', type: 'label' }]);
      }
      return result.concat(this.suggestions.map(s => ({ ...s, type: 'suggestion' })));
    }
  },
  methods: {
    addSuggestion(s) {
      this.concerns.push(s);
      const n = this.suggestions.findIndex(con => con.text == s.text);
      this.suggestions.splice(n, 1);
    },
    removeConcern(c) {
      const n = this.concerns.findIndex(con => con.text == c);
      this.concerns.splice(n, 1);
    },
    removeSuggestion(s) {
      const n = this.suggestions.findIndex(con => con.text == s.text);
      this.suggestions.splice(n, 1);
    }
  }
};
</script>

<style></style>
